import axios, { AxiosResponse } from 'axios'

import { env } from '@js/utils/env'
import gql from '@js/api/utils/gql'
import getStoreName from '@js/api/utils/getStoreName'
import getBearerToken from '@js/api/utils/getBearerToken'
import { CustomerLicenseProfession } from '@js/api/types/customer/CustomerLicenseProfession'

export interface GetCustomerLicenseProfessionResponse {
  data: {
    getCustomerLicenseProfession: CustomerLicenseProfession[]
  }
  errors?: [{ message: string }]
}

export const customerLicenseProfessionsQuery = gql`
  query GetCustomerLicenseProfession($stateCode: String!) {
    getCustomerLicenseProfession(state_code: $stateCode) {
      id
      profession_name
    }
  }
`

/**
 * @throws {string}
 *
 * Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 */
export const getCustomerLicenseProfessions = async (stateCode: string): Promise<CustomerLicenseProfession[]> => {
  const bearerToken = getBearerToken()

  const { data }: AxiosResponse<GetCustomerLicenseProfessionResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
      Store: getStoreName(),
    },
    data: {
      query: customerLicenseProfessionsQuery,
      variables: {
        stateCode,
      },
    },
  })

  if (data.errors) {
    throw data.errors[0].message
  }

  return data.data.getCustomerLicenseProfession
}
